// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dogs-viewer__error {\n  color: #ff3535;\n  margin: 1rem 0;\n  text-align: center;\n}\n\n.dogs-viewer__success {\n  text-align: center;\n  margin-top: 0.5rem;\n}\n\n.dogs-viewer__images {\n  display: grid;\n  grid-row-gap: 1rem;\n  justify-items: center;\n  padding: 1rem;\n}\n\n.dogs-viewer__image {\n  max-width: 100%;\n  height: 360px;\n}\n", ""]);
// Exports
module.exports = exports;
